import React, { useState } from 'react';
import { showAppAlert } from '../utils/alertService';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function AddPlansModal({ visible, onClose, onAdd }) {
  const [formData, setFormData] = useState({
    nome: '',
    valor: '',
    qtd_companies: '',
    descricao: '',
  });
  const [loading, setLoading] = useState(false);

  if (!visible) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let descricaoObj;
    try {
      descricaoObj = JSON.parse(formData.descricao);
    } catch {
      descricaoObj = { suporte: 1 };
    }

    const payload = {
      nome: formData.nome,
      valor: Number(formData.valor),
      qtd_companies: Number(formData.qtd_companies),
      descricao: descricaoObj,
    };

    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${API_URL}/plans`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.status === 201) {
        showAppAlert('success', 'Plano cadastrado com sucesso');
        setFormData({ nome: '', valor: '', qtd_companies: '', descricao: '' });
        if (onAdd) onAdd();
        onClose();
      } else {
        showAppAlert('error', data.message || 'Plano não cadastrado');
      }
    } catch (error) {
      showAppAlert('error', 'Plano não cadastrado');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Cadastrar Plano</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome:</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
              className="input-style"
            />
          </div>
          <div className="form-group">
            <label>Valor:</label>
            <input
              type="number"
              name="valor"
              value={formData.valor}
              onChange={handleChange}
              required
              step="0.01"
              className="input-style"
            />
          </div>
          <div className="form-group">
            <label>Quantidade de Empresas:</label>
            <input
              type="number"
              name="qtd_companies"
              value={formData.qtd_companies}
              onChange={handleChange}
              required
              className="input-style"
            />
          </div>
          <div className="form-group">
            <label>Descrição (JSON):</label>
            <textarea
              name="descricao"
              value={formData.descricao}
              onChange={handleChange}
              placeholder='Ex: {"suporte":1}'
              required
              className="input-style"
            />
          </div>
          <div className="button-container">
            <button type="submit" className="button-style" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
            <button type="button" className="button-style cancel" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddPlansModal;